import services from '@/config/services'

export default class ModuloSdiFattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getFatturePerSdi(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/per-sdi/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async makeSdiArchive(opts = {}){
    let success = false
    const url = `${this.baseUrl}/clienti/fatture/sdi/archivio/zip`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async getArchivesByYear(year){
    let item = {}

    const url = `${this.baseUrl}/clienti/fatture/sdi/zip/${year}`
    
    try {
      let res = await this.http.get(url)
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async downloadZip(fileName){
    const url = `${this.baseUrl}/clienti/fatture/sdi/${fileName}`
    
    const httpConfig = {
      url,
      method: 'POST',
      responseType: 'blob',
    }

    try {
      const res = await this.http(httpConfig)
      
      const blob = new Blob([res.data], {type: 'application/zip'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

}
